import { ComponentProps } from 'react'

export function Button({ className, ...props }: ComponentProps<'button'>) {
  return (
    <button
      className={`${'font-handwriting hover:bg-gray-600 hover:border-solid hover:text-white text-lg border-dotted border px-4 py-2 rounded-lg'} ${className}`}
      {...props}
    />
  )
}
